import RoleBadge from "../RoleBadge/RoleBadge";
import "./RoleBadgeList.css";

const RoleBadgeList = ({ roles }) => {
  if (!roles || roles.length === 0) return null;

  return (
    <div className="role-badge-list">
      {roles.map((role) => (
        <RoleBadge key={role.id} name={role.name} color={role.color} />
      ))}
    </div>
  );
};

export default RoleBadgeList;
